<template>
  <v-app>
    <v-card tile color="transparent">
      <v-row class="m-3" v-if="data != null" :loading="loading">

        <v-flex class="m-3" sm="12" md="6">
          <div>
            <request-details :request="data"/>
          </div>
        </v-flex>

        <v-flex class="m-3" sm="12" md="6">
          <user-details :details="user"/>
        </v-flex>

      </v-row>


    </v-card>

  </v-app>
</template>

<script>
import RequestDetails from "@/view/pages/admin/transactions/userInfo/requestDetails";
import Business from "@/view/pages/admin/confirm/userInfo/Business";
import UserDetails from "@/view/pages/admin/confirm/userInfo/userDetails";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import UserJobs from "@/view/pages/admin/users/actions/userJobs";

export default {
  name: "Information",
  components: {UserJobs, UserDetails, Business, RequestDetails},
  props: ['id'],
  data() {
    return {
      data: [],
      user: {},
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      url: 'authRequest',
      userInfo: {},
      transactions: {},
      packs: {},
      transactionUrl: 'userTransaction',
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      loading: false,

      columnTransactions: [
        {
          name: 'uuid',
          label: 'شناسه پرداخت',
          orderable: true,

        },
        {
          name: 'amount',
          label: 'قیمت(﷼)',
          orderable: true,
          transform: (value) => {
            return this.$options.filters.rial(value.data.amount);
          },
        },
        {
          name: 'type',
          label: 'نوع',
          transform: (value) => {
            return value.data.type === 'deposit'
                ? `<span class="badge-pill badge badge-success">افزایش موجودی</span>`
                : `<span class="badge-pill badge badge-danger">کسر موجودی</span>`
          }
        },
        {
          name: 'confirmed',
          label: 'وضعیت',
          transform: (value) => {
            return value.data.confirmed === true
                ? `<span class="badge-pill badge badge-info">تایید شده</span>`
                : `<span class="badge-pill badge badge-danger">تایید نشده</span>`
          }

        },

      ],
    }
  },
  created() {
    this.getUserInfo();
    this.getUserTransactions(this.transactionUrl);
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
  },

  methods: {
    getUserInfo() {
      this.loading = true;
      this.requestApiGet('admin/transactions/' + this.id).then(({data}) => {
        this.data = data;
        console.log(data)
        this.user = data.user;
        this.loading = false;
      });
    },
    getUserTransactions(url = this.transactionUrl, params = this.tableProps) {
      this.loading = true;
      this.requestApiGet(`${url}/${this.id}`, params).then(response => {
        this.transactions = response.data;
        this.loading = false;
      });
    },
    reloadTable(tableProps) {
      this.getUserTransactions(this.transactionUrl, tableProps);
    },

  },

}
</script>

<style scoped>

</style>